import { render } from "./FormBatchMasuk.vue?vue&type=template&id=2d7ceace"
import script from "./FormBatchMasuk.vue?vue&type=script&lang=js"
export * from "./FormBatchMasuk.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__